module.exports = __webpack_public_path__ + "img/RedteaSIM_01.b949a64b.jpeg";